/**
 * @desc 配置文件
 * @auth Vman
 */

let config = {
  sdk: 'NIM_Web_SDK_v6.1.0',
  useDb: true,
  // defaultUserIcon: require( '../assets/images/default-avatar-doctor.png' ),
  // defaultUserPatientsIcon: require( '../assets/images/default-avatar-patient.png' ),
  defaultUserIcon: require( '../assets/images/doctor-avatar.svg' ),
  defaultUserPatientsIcon: require( '../assets/images/user-avatar.svg' ),
  localMsglimit: '',
  loginUrl: '',
  registUrl: '',
  //超级管理员
  superImAccId: process.env.VUE_APP_IM_SUPPER_ID,
  testUid: '3395826400551810000', //18210506646
  testSdkToken: '6721e291808cbe3fcac5ea687bdd20f2',
  target:'7291891262874206481', //15909581102
  ImageUrl: 'https://static.doctor.uat.lejian.com',
};
let appConfig = {
    appkey: process.env.VUE_APP_IM_KEY,
    postUrl: 'https://app.netease.im'
};
config = Object.assign( config, appConfig );
export default config